<app-sidenav>
    <div class="container p-5">
        <div class="row mt-3">
            <div class="custom-box-wrapper d-flex align-items-center justify-content-between flex-wrap p-5">
                <div class="text-box">
                    <h2 class="custom-title">
                        Bem Vindo <br>
                        <span class="custom-portal">Portal Investidores FGC</span>
                    </h2>
                </div>
                <div class="image-box">
                    <img width="500px" src="../../../../assets/logos/fgc-logo.svg" alt="Logo FGC(Fundo Garantidor de Créditos)">
                </div>
            </div>
        </div>
    </div>
</app-sidenav>